import React from 'react';
import { PesquisaScorpion, FiltroStringScorpion,FiltroCompoboxScorpion } from 'scorpion-core'

class OkReportDeveloperPesquisa extends React.Component {

  constructor(props) {
    super(props);
  }

  state = {
    open: false,
  };

  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };



  componentWillMount() {
    this.props.listar();
  }

  colunas() {
    let colunas = [
      { label: "UID", getValue: item => item.uid },
      { label: "Nome", getValue: item => item.nome },
      { label: "Descrição", getValue: item => item.descricao },
      { label: "Concluido", getValue: item => item.concluido ? "Sim" : "Não" },
    ];

    return colunas;
  }

  render() {
    const { listaPesquisa, loadingListaPesquisa, } = this.props;

    return (<div>
      <PesquisaScorpion
        titulo={"Pesquisa de Relatórios"}
        columns={this.colunas()}
        data={listaPesquisa}
        loadingPesquisa={loadingListaPesquisa}
        getID={(item, index) => item.uid}
        {...this.props}
      >

        <FiltroStringScorpion name="filtroUID" label="UID"
          strComparaLike={item => item.uid}
          criaSugestaoPorLike={listaPesquisa} />

        <FiltroStringScorpion name="filtroNome" label="Nome"
          strComparaLike={item => item.nome}
          criaSugestaoPorLike={listaPesquisa} />
        <FiltroStringScorpion name="filtroDescricao" label="Descrição"
          strComparaLike={item => item.descricao}
          criaSugestaoPorLike={listaPesquisa} />
        <FiltroCompoboxScorpion name="filtroconcluido" label="Concluido" itens={["Sim", "Não"]} placeholder="Exibir Concluidos"
          atende={(obj, filtro) => {
            if (filtro === "Sim") {
              if (obj.concluido) {
                return true;
              } else {
                return false;
              }
            } else {
              return true;
            }
          }}
        />

      </PesquisaScorpion>

    </div>
    )
  }
}


export default OkReportDeveloperPesquisa;




// WEBPACK FOOTER //
// ./src/routes/sistema/OkReportDeveloper/components/OkReportDeveloperPesquisa/OkReportDeveloperPesquisa.js